module.exports = __webpack_public_path__ + "img/inspiration_04@2x.2dc0d79.jpg";